import React, { useEffect, useState } from 'react';
import { Select, InputNumber } from 'antd';

import styles from './index.less';

const options = [
  { label: '大于', value: 'gt' },
  { label: '小于', value: 'lt' },
  { label: '范围', value: 'range' }
];

const optMap = {
  gt: '大于',
  lt: '小于',
  range: '范围'
};

const defaultCount = { count: 0, max: 0, min: 0 };

const CountRange = props => {
  const { onChange, value } = props;
  const [operator, setOperator] = useState('gt');
  const [count, setCount] = useState({ ...defaultCount });

  useEffect(() => {
    if (value) {
      setOperator(value?.operator || 'gt');
      setCount(value?.count || { ...defaultCount });
    }
  }, [value]);

  const renderCountText = (opt, count) => {
    switch (opt) {
      case 'gt':
        return `${count.count}次 `;
      case 'lt':
        return `${count.count}次 `;
      case 'range':
        return `${count.min}次-${count.max}次 `;
    }
  };

  const onSelect = e => {
    setOperator(e);
    onChange({ operator: e, count, label: `${optMap[e]}${renderCountText(e, count)}` });
  };

  const onInputChange = (data, type) => {
    const newCount = { ...count, [type]: data };
    setCount(e => ({ ...e, [type]: data }));
    onChange({ label: `${optMap[operator]}${renderCountText(operator, newCount)}`, operator, count: newCount });
  };

  return (
    <div className={styles.wrap}>
      <Select onSelect={onSelect} value={operator}>
        {options.map(item => {
          return <Select.Option value={item.value}>{item.label}</Select.Option>;
        })}
      </Select>
      {operator === 'range' ? (
        <>
          <InputNumber
            min={0}
            value={count?.min}
            onChange={e => onInputChange(e, 'min')}
            className={styles.w64}
          ></InputNumber>
          -
          <InputNumber
            min={0}
            value={count?.max}
            onChange={e => onInputChange(e, 'max')}
            className={styles.w64}
          ></InputNumber>
          次
        </>
      ) : (
        <>
          <InputNumber
            min={0}
            value={count?.count}
            className={styles.w64}
            onChange={e => onInputChange(e, 'count')}
          ></InputNumber>
          次
        </>
      )}
    </div>
  );
};

export default CountRange;
